import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Link, useParams } from 'react-router-dom';

import { ArrowRight, CheckCheck } from "lucide-react";
import { LuRefreshCw } from "react-icons/lu";

import axiosInstance from 'utils/axiosInstance';

import { TransitionGroup, CSSTransition } from 'react-transition-group';

const LatestStatsComments = ({ 
  t, 
}) => {

  return (
    <Col xs={12} style={{ background: "lightgrey" }}>

    	<Row>
    		<Col xs={12}>

    			<div style={{
    				paddingTop: "15px",
    				paddingLeft: "10px"
    			}}>
    				<h5>最新留言</h5>
    			</div>


    		</Col>
    	</Row>



    </Col>
  );
};

export default withTranslation()(LatestStatsComments);


